import {DeleteConfirmationParams} from '../types/confirmation-modal.types';
import {BaseConfirmModalComponent} from '../components/modals/base-confirm-modal/base-confirm-modal.component';

export const defaultDeleteConfirmationParams: DeleteConfirmationParams = {
  component: BaseConfirmModalComponent,
  titleText: 'Удалить запись',
  description: 'Вы уверены, что хотите удалить запись?',
  buttonWarmText: 'Удалить',
  buttonPrimaryText: 'Назад'
}
